import { MenuData } from './../../communication-structure/menu-button-data';
import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss']
})
export class MenuButtonComponent extends BaseComponent implements OnInit {
  public buttonClass: string;
  public menuId: string;
  @Input() public selectedIndex: number;

  public menuItems: Array<{ id: number, name: string }>;
  isExpanded: boolean;

  @ViewChild('menu') menuRef: ElementRef;

  @Input() set menuData (value: MenuData){
    if (!isNullOrUndefined(value)) {
      this.buttonClass = value.buttonClass;
      this.menuId = value.menuId;
      this.menuItems = value.options;
    }
  }

  @Input() menuWidth: number;
  @Input() menuHeight: number;

  @Output() menuItemSelected = new EventEmitter();

  mouseDownHandler: EventListenerObject;

  constructor(ele: ElementRef) {
    super(ele);
    this.isExpanded = false;
  }

  ngOnInit() {
  }

  onMenuItemClicked(menuItem: { id: number, name: string }) {
    this.isExpanded = false;
    this.closeSimulatePopup();
    this.menuItemSelected.emit(menuItem);
  }

  hideMenuItems() {
    this.isExpanded = false;
    this.closeSimulatePopup();
  }

  toggleMenuItems() {
    this.isExpanded = !this.isExpanded;
    if (this.isExpanded) {
      this.mouseDownHandler = this.onMouseDown.bind(this);
      window.addEventListener('pointerdown', this.mouseDownHandler);
      window.addEventListener('touchstart', this.mouseDownHandler);
      window.addEventListener('mousedown', this.mouseDownHandler);
      window.addEventListener('click', this.mouseDownHandler);
      setTimeout(() => {
        this.setFocusOnSelectedElement();
      }, 0);
    } else {
      this.closeSimulatePopup();
    }
  }
  setFocusOnSelectedElement() {
    if (this.menuRef) {
        (this.menuRef.nativeElement as HTMLElement).scrollTop = 40 * this.selectedIndex;
    }
  }

  closeSimulatePopup() {
    window.removeEventListener('pointerdown', this.mouseDownHandler);
    window.removeEventListener('touchstart', this.mouseDownHandler);
    window.removeEventListener('mousedown', this.mouseDownHandler);
    window.removeEventListener('click', this.mouseDownHandler);
  }

  onMouseDown(event) {
    let element: any = event.target;
    const dropDownContainer: HTMLElement = document.getElementById(this.menuId + '-container');

    while (element != null) {
      if (element === dropDownContainer) {
        return;
      }
      element = element.parentElement;
    }
    this.closeSimulatePopup();
    this.isExpanded = false;
  }
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/menu-button/menu-button.component.ts